import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling11(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_11 } = texts;
  const { values, errors, touched } = formikProps;

  return (
    <AccordionItem value="Handling11">
      <AccordionHeader
        sectionStarted={
          !!values.revisors_handling_11_question ||
          !!values.revisors_handling_11_periode_fra ||
          !!values.revisors_handling_11_periode_til
        }
        sectionComplete={isCompleteHelpers.revisors_handling_11_complete}
        ref={refs.handling_11_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_10_ref);
        }}
      >
        {revisors_handling_11.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <div className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_11.description}
            <div className="row align-items-center">
              <label
                className="form-label col-auto"
                htmlFor={
                  revisors_handling_11.revisors_handling_11_periode_fra.id
                }
              >
                {revisors_handling_11.revisors_handling_11_periode.label}
              </label>
              <div className="form-control form-control--group w-auto">
                <div className="position-relative">
                  <ValidatedField
                    touched={touched.revisors_handling_11_periode_fra}
                    error={errors.revisors_handling_11_periode_fra}
                    type="date"
                    additionalClasses="border-0"
                    name={
                      revisors_handling_11.revisors_handling_11_periode_fra.id
                    }
                    id={
                      revisors_handling_11.revisors_handling_11_periode_fra.id
                    }
                  />
                </div>
                -
                <div className="position-relative">
                  <ValidatedField
                    touched={touched.revisors_handling_11_periode_til}
                    error={errors.revisors_handling_11_periode_til}
                    type="date"
                    additionalClasses="border-0"
                    name={
                      revisors_handling_11.revisors_handling_11_periode_til.id
                    }
                    id={
                      revisors_handling_11.revisors_handling_11_periode_til.id
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_11.revisors_handling_11_question.id}
              id={
                revisors_handling_11.revisors_handling_11_question
                  .revisors_handling_11_question_alt_1.value
              }
              value={
                revisors_handling_11.revisors_handling_11_question
                  .revisors_handling_11_question_alt_1.value
              }
              text={
                revisors_handling_11.revisors_handling_11_question
                  .revisors_handling_11_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_11.revisors_handling_11_question.id}
              id={
                revisors_handling_11.revisors_handling_11_question
                  .revisors_handling_11_question_alt_2.value
              }
              value={
                revisors_handling_11.revisors_handling_11_question
                  .revisors_handling_11_question_alt_2.value
              }
              text={
                revisors_handling_11.revisors_handling_11_question
                  .revisors_handling_11_question_alt_2.label
              }
            >
              <label
                htmlFor={
                  revisors_handling_11.revisors_handling_11_alt_2_uddybning.id
                }
                className="mb-2"
              >
                {
                  revisors_handling_11.revisors_handling_11_alt_2_uddybning
                    .label
                }{" "}
                <span className="text-muted">
                  {
                    revisors_handling_11.revisors_handling_11_alt_2_uddybning
                      .sublabel
                  }
                </span>
                :
              </label>
              <ValidatedField
                touched={touched.revisors_handling_11_alt_2_uddybning}
                error={errors.revisors_handling_11_alt_2_uddybning}
                autoComplete="off"
                as="textarea"
                id={
                  revisors_handling_11.revisors_handling_11_alt_2_uddybning.id
                }
                name={
                  revisors_handling_11.revisors_handling_11_alt_2_uddybning.id
                }
                placeholder="Beskrivelse"
                rows={2}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
